module.exports = __webpack_public_path__ + "static/media/400156_02.12c8d4a8.png";